import { Card, CardBody, Stack, Icon, Tag, Text, useColorModeValue } from '@chakra-ui/react';
import { IconType } from 'react-icons';

export interface BulkTagCardProps {
  icon: IconType;
  label: string;
  tagColorScheme: string;
  selected?: boolean;
  onClick?: () => void;
}

export default function BulkTagCard({ icon, label, tagColorScheme, selected = false, onClick }: BulkTagCardProps) {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const selectedBorderColor = useColorModeValue(`${tagColorScheme}.500`, `${tagColorScheme}.300`);
  const selectedBgColor = useColorModeValue(`${tagColorScheme}.50`, `${tagColorScheme}.900`);
  const hoverBgColor = useColorModeValue('gray.50', 'gray.700');

  return (
    <Card
      variant="outline"
      borderRadius="lg"
      borderWidth="2px"
      borderColor={selected ? selectedBorderColor : borderColor}
      backgroundColor={selected ? selectedBgColor : 'transparent'}
      cursor="pointer"
      onClick={onClick}
      transition="all 0.2s"
      _hover={{
        backgroundColor: selected ? selectedBgColor : hoverBgColor,
        borderColor: selected ? selectedBorderColor : 'gray.300',
        transform: 'translateY(-2px)',
        shadow: 'md'
      }}
      minW="180px"
      maxW="200px"
      aspectRatio="1"
    >
      <CardBody display="flex" alignItems="center" justifyContent="center">
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Icon as={icon} w={12} h={12} color={selected ? selectedBorderColor : 'gray.500'} />
          <Tag size="md" variant="solid" colorScheme={tagColorScheme}>
            {label}
          </Tag>
          <Text fontSize="md" fontWeight="semibold" color={selected ? selectedBorderColor : 'gray.700'}>
            {label}
          </Text>
        </Stack>
      </CardBody>
    </Card>
  );
}
